import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import Heading from "../../../component/Heading/Heading";
import DashboardCard from "./DashboardCard";
import invoiceIcon from "../../../assets/icons/invoice.svg";
import groupIcon from "../../../assets/icons/group.svg";
import verbindlichkeitenIcon from "../../../assets/icons/verbindlichkeiten.svg";
import darlehenIcon from "../../../assets/icons/darlehen.svg";

import "../../../styles/pages/customer/dashboard.scss";
import { useTranslation } from "react-i18next";
import DashboardChart from "./DashboardChart";
import { getDashboardDataList } from "../../../services/customer-services/customerDashboardService";
import { useEffect, useState } from "react";
import { formatGermanPercentage } from "../../../helper/formatAmount";
import { getLiquiditätsbilanz2List } from "../../../services/customer-services/customerLiquiditätsbilanz";
import { useCommonContext } from "../../../context/common";
import SelectCustomerPage from "../select-customer/SelectCustomerPage";
import { getManualCrifScore } from "../../../services/customer-services/crifService";
import CrifScoreCard from "../../customer/dashboard/CrifScoreCard"; // Use the customer component for display

const Dashboard = () => {
  const { t } = useTranslation();
  const [dashboardData, setDashboardData] = useState({});
  const [totals, setTotals] = useState({});
  const [crifScore, setCrifScore] = useState(null); // New state for Crif Score
  const [lastCrifUpdate, setLastCrifUpdate] = useState(null);
  const [isCrifLoading, setIsCrifLoading] = useState(true);
  const { clientId } = useCommonContext();

  const data = [
    {
      icon: invoiceIcon,
      name: "dashboard_verrechnungssaldo",
      total: dashboardData?.verrechnungssaldo ?? 0,
    },
    {
      icon: groupIcon,
      name: "forderungen_heading",
      total: dashboardData?.forderungen ?? 0,
    },
    {
      icon: verbindlichkeitenIcon,
      name: "verbindlichkeiten_heading",
      total: dashboardData?.verbindlichkeiten ?? 0,
    },
    {
      icon: darlehenIcon,
      name: "dashboard_darlehen",
      total: dashboardData?.darlehnen ?? 0,
    },
  ];

  const getDashboardData = async () => {
    if (clientId) {
      const response = await getDashboardDataList(clientId);
      if (response?.isSuccess) {
        setDashboardData({ ...response.data });
      } else {
        setDashboardData({});
      }
    }
  };

  const getLiquiditätsbilanz = async () => {
    if (clientId) {
      const response = await getLiquiditätsbilanz2List(clientId);
      if (response?.isSuccess) {
        setTotals(response?.totals);
      } else {
        setTotals({});
      }
    }
  };

  const fetchCrifScore = async () => {
    setIsCrifLoading(true);
    if (clientId) {
      const response = await getManualCrifScore(clientId);
      if (response?.isSuccess) {
        console.log(response);
        setCrifScore(response.crifScore);
        setLastCrifUpdate(response.lastUpdated);
        console.log(response.lastUpdated);
      } else {
        setCrifScore(null);
        setLastCrifUpdate(null);
      }
    }
    setIsCrifLoading(false);
  };

  useEffect(() => {
    getDashboardData();
    getLiquiditätsbilanz();
    fetchCrifScore(); // Fetch Crif Score
  }, [clientId]);

  const totalRatio =
    totals?.totalPassivaWert && totals.totalPassivaWert !== 0
      ? (totals.totalAktivaWert / totals.totalPassivaWert) * 100
      : 0;

  if (!clientId) {
    return <SelectCustomerPage />;
  }

  return (
    <div className="dashboard-wrapper">
      <div className="dashboard-heading flex items-center justify-between">
        <Heading text={t("module_dashboard")} className="heading" />
      </div>
      <Grid container sx={{ marginTop: "0rem" }} spacing={3.5}>
        {data?.map((item, index) => (
          <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={index}>
            <DashboardCard item={item} t={t} />
          </Grid>
        ))}
      </Grid>
      <Box>
        <Grid container sx={{ marginTop: "0rem" }} spacing={3.5}>
          {/* Liquiditätsbilanz Card - Adjusted to md={8} */}
          <Grid item xs={12} md={8}>
            <Card
              variant="outlined"
              sx={{
                background: "#fff",
                height: "100%",
                padding: "10px",
                borderRadius: "10px",
              }}
            >
              <CardContent sx={{ background: "#fff" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography>{t("dashboard_liquiditatbianz")} 1</Typography>
                  <Typography>
                    {formatGermanPercentage(dashboardData?.liquiditatbianzOne)}%
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    paddingTop: "10px",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography>{t("dashboard_liquiditatbianz")} 2</Typography>
                  <Typography>{formatGermanPercentage(totalRatio)}%</Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Crif Score Card - New addition md={4} */}
          <Grid item xs={12} md={4}>
            <CrifScoreCard
              score={crifScore}
              lastUpdated={lastCrifUpdate}
              editable={false}
              isLoading={isCrifLoading}
              onRefresh={fetchCrifScore}
            />
          </Grid>
        </Grid>
      </Box>
      <Box>
        <DashboardChart clientId={clientId} />
      </Box>
    </div>
  );
};

export default Dashboard;
